import {
  useHtzPositionCatalogShowActiveCatalogQuery,
  useHtzPositionCatalogShowQuery,
} from "@/services/backend/htz/position-catalog/api/position-catalog-api";

/**
 * useActivePositionCatalog loads the position catalog which is active for the company.
 * The catalog is undefined while it loads or when the company has no active
 * catalog.
 */
export function useActivePositionCatalog(companyId: string) {
  const {
    data: activeCatalog,
    isLoading: activeCatalogIsLoading,
    error: activeCatalogError,
  } = useHtzPositionCatalogShowActiveCatalogQuery(
    { companyId },
    { skip: !companyId },
  );

  const {
    data: catalog,
    isLoading: catalogIsLoading,
    error: catalogError,
  } = useHtzPositionCatalogShowQuery(
    { id: activeCatalog?.catalogId ?? "" },
    {
      skip: activeCatalog === undefined || activeCatalog.catalogId === null,
    },
  );

  return {
    data: catalog,
    isLoading: activeCatalogIsLoading || catalogIsLoading,
    error: activeCatalogError || catalogError,
  };
}
